import { addPopoutV2 } from 'owa-popout-v2';

export default function popoutAddCalendarPane(entrySource: string) {
    addPopoutV2('calendar', 'addcalendar', entrySource);
}
